/**
 * Majlis Mart - finishing touches: header elevation on scroll, back-to-top button,
 * and gentle scroll-reveal on the home page. Content stays visible if anything here fails.
 */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var header = doc.querySelector('.site-header');
    var isAr = doc.documentElement.lang === 'ar';

    var top = doc.createElement('button');
    top.type = 'button';
    top.className = 'mm-top';
    top.setAttribute('aria-label', isAr ? 'العودة إلى الأعلى' : 'Back to top');
    top.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    doc.body.appendChild(top);

    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || doc.documentElement.scrollTop || 0;
      if (header) header.classList.toggle('is-scrolled', y > 8);
      top.classList.toggle('is-visible', y > 700);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();

    // Scroll reveal: home page only, only for content that starts below the fold.
    if (reduce || !('IntersectionObserver' in window) || !doc.body.classList.contains('template-index')) return;
    var selector = '.mm-section-head, .mm-category-card, .mm-home-product-card, .mm-lx-feature__media, .mm-lx-feature__copy, .mm-promo__card, .promo-banner .rounded-3xl, .faq-section';
    var vh = window.innerHeight || 800;
    var items = Array.prototype.filter.call(doc.querySelectorAll(selector), function (el) {
      return el.getBoundingClientRect().top > vh * 0.92;
    });
    if (!items.length) return;

    doc.documentElement.classList.add('mm-js');
    var seen = new Map();
    items.forEach(function (el) {
      var parent = el.parentElement;
      var n = seen.get(parent) || 0;
      seen.set(parent, n + 1);
      el.style.setProperty('--mm-d', Math.min(n, 5) * 70 + 'ms');
      el.classList.add('mm-reveal');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('is-in');
        // Hand the element back to its own hover styles once the reveal has finished.
        setTimeout(function () { el.classList.remove('mm-reveal', 'is-in'); el.style.removeProperty('--mm-d'); }, 1300);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });

    // Safety net: never leave anything hidden.
    setTimeout(function () {
      doc.querySelectorAll('.mm-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
    }, 6000);
  });
})();
